import { FC } from 'react';
import './styles.scss';

type ExtraLogsProps = {
  extraLogsIsShown: boolean;
  setExtraLogsIsShown: (extraLogsIsShown: boolean) => void;
  logCount: number;
};

const ExtraLogs: FC<ExtraLogsProps> = ({ extraLogsIsShown, setExtraLogsIsShown, logCount }: ExtraLogsProps) => (
  <div
    role="button"
    tabIndex={0}
    className="LogsView__ExtraLogs"
    onClick={(): void => {
      setExtraLogsIsShown(!extraLogsIsShown);
    }}
  >
    {!extraLogsIsShown ? `+ Show ${logCount > 9 ? 8 : logCount - 2} more (of ${logCount - 2})` : '- Show fewer'}
  </div>
);

export default ExtraLogs;
